import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useOutletContext } from "react-router";
import {
  getPersonalSpaceQueryKey,
  getSpaceHubQueryKey,
  getSpaceQueryKey,
  listPinsQueryKey,
  listSpacesQueryKey,
  type SpaceHubResponse,
} from "@/api";

/** The space being edited, handed to each settings section by the layout. */
export interface SpaceSettingsContext {
  space: SpaceHubResponse;
}

export function useSettingsSpace(): SpaceHubResponse {
  return useOutletContext<SpaceSettingsContext>().space;
}

/** Refresh everything that shows a space: its page, the lists and the sidebar. */
export function useRefreshSpace(spaceUuid: string) {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: getSpaceHubQueryKey({ path: { space_uuid: spaceUuid } }) }),
        queryClient.invalidateQueries({ queryKey: getSpaceQueryKey({ path: { space_uuid: spaceUuid } }) }),
        queryClient.invalidateQueries({ queryKey: listSpacesQueryKey() }),
        queryClient.invalidateQueries({ queryKey: listPinsQueryKey() }),
        queryClient.invalidateQueries({ queryKey: getPersonalSpaceQueryKey() }),
      ]),
    [queryClient, spaceUuid],
  );
}
